import CognitoUserAdd from './abstract/CognitoUserAdd'
import Config from '../../../Config'

class CompanyAdd extends CognitoUserAdd {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.nameTitle = '企業名'
    this.apiUrl = Config.companyAdminApiUrl.selfUserNoLogin
    this.userRoleName = '企業'
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
  }
  componentWillMount () {
    this.loadUserDetail()
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        this.props.history.push('/company_admin/login')
        break
      default:
        break
    }
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const companyAdmin = this.state
    const detailUrl = '/company_admin/company/detail'
    switch (name) {
      case 'save':
        this.addUserNoLogin(companyAdmin, detailUrl)
        break
      case 'cancel':
        this.props.history.push(detailUrl)
        break
      default:
        break
    }
  }
}

export default CompanyAdd



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/CompanyAdd.js